const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  REGISTER: 'user/REGISTER',
  USER_DETAIL: 'user/USER_DETAIL',
  LOGOUT: 'user/LOGOUT',
  UPDATE_BUSINESS: 'user/update/BUSINESS',
  UPDATE_USER: 'user/update/user',
  RESET_APP: 'user/reset_app',
  UPDATE_PARTNER: 'user/update/partner',
}

export default actions
